import React from "react";
import { ScrollView, StyleSheet, Modal, Text, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { connect } from "react-redux";
import t from "@constants/localization";
import Header from "./Header";
import Content from "./Content";
import colors from "../../constants/color";
import { Fab } from "./Fab";

const PATH = "screens/WithdrawMoney/index";

const textMap = {
  ccfp: {
    headerTitle: t(`${PATH}/ccfp/headerTitle`),
    headerSubTitle: t(`${PATH}/ccfp/headerSubTitle`),
    contentHeading: t(`${PATH}/ccfp/contentHeading`),
    contentDesc: t(`${PATH}/ccfp/contentDesc`),
  },
  default: {
    headerTitle: t(`${PATH}/default/headerTitle`),
    headerSubTitle: t(`${PATH}/default/headerSubTitle`),
    contentHeading: t(`${PATH}/default/contentHeading`),
    contentDesc: t(`${PATH}/default/contentDesc`),
  },
};

class WithdrawMoney extends React.Component {
  state = {
    bankSelected: true,
    upiSelected: false,
    showfab: false,
  };

  setShowFab = (value) => {
    this.setState({ showfab: value });
  };

  renderAddAccountIcon = ({ wallet, navigation, textMapKey }) => {
    const { fundAccountsData = [] } = wallet;
    if (fundAccountsData.length == 0) return <></>;
    else {
      const upi = fundAccountsData.filter((acc) => !!acc.upi_address);
      const bankAcc = fundAccountsData.filter((acc) => !!acc.account_number);
      if (this.state.upiSelected && upi.length) {
        return (
          <Fab
            onPress={() => {
              navigation.navigate("AddNewUpi", { from: textMapKey });
            }}
          />
        );
      } else if (this.state.bankSelected && bankAcc.length) {
        return (
          <Fab
            onPress={() => {
              navigation.navigate("AddBankDetails", { from: textMapKey });
            }}
          />
        );
      } else return <></>;
    }
  };

  render() {
    const { navigation, route, wallet } = this.props;
    const textMapKey = route.params?.from ?? "default";
    return (
      <SafeAreaView style={styles.container}>
        <Header
          headerTitle={textMap[textMapKey].headerTitle}
          headerSubTitle={textMap[textMapKey].headerSubTitle}
          navigation={navigation}
          from={textMapKey}
        />
        <ScrollView keyboardShouldPersistTaps="always">
          <Content
            title={t(`${PATH}/selectBankAcc`)}
            contentHeading={textMap[textMapKey].contentHeading}
            contentDesc={textMap[textMapKey].contentDesc}
            bankSelected={this.state.bankSelected}
            upiSelected={this.state.upiSelected}
            bankPress={() =>
              this.setState({ bankSelected: true, upiSelected: false })
            }
            upiPress={() =>
              this.setState({ bankSelected: false, upiSelected: true })
            }
            from={textMapKey}
            navigation={navigation}
          />
        </ScrollView>
        {this.renderAddAccountIcon({ wallet, navigation, textMapKey })}
      </SafeAreaView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#f7f7f7",
  },
});

const mstp = ({ wallet }) => {
  return {
    wallet,
  };
};

export default connect(mstp)(WithdrawMoney);
